const types = {
  //Get Request List
  GET_QUOTATION_START: "GET_QUOTATION_START",
  GET_QUOTATION_SUCCESS: "GET_QUOTATION_SUCCESS",
  GET_QUOTATION_ERROR: "GET_QUOTATION_ERROR",
  GET_QUOTATION_RESET: "GET_QUOTATION_RESET",

  //Create Request
  CREATE_QUOTATION_START: "CREATE_QUOTATION_START",
  CREATE_QUOTATION_SUCCESS: "CREATE_QUOTATION_SUCCESS",
  CREATE_QUOTATION_ERROR: "CREATE_QUOTATION_ERROR",
  CREATE_QUOTATION_RESET: "CREATE_QUOTATION_RESET",

  //Update Request
  UPDATE_QUOTATION_START: "UPDATE_QUOTATION_START",
  UPDATE_QUOTATION_SUCCESS: "UPDATE_QUOTATION_SUCCESS",
  UPDATE_QUOTATION_ERROR: "UPDATE_QUOTATION_ERROR",
  UPDATE_QUOTATION_RESET: "UPDATE_QUOTATION_RESET",

  //Delete Request
  DELETE_QUOTATION_START: "DELETE_QUOTATION_START",
  DELETE_QUOTATION_SUCCESS: "DELETE_QUOTATION_SUCCESS",
  DELETE_QUOTATION_ERROR: "DELETE_QUOTATION_ERROR",
  DELETE_QUOTATION_RESET: "DELETE_QUOTATION_RESET",

  //Single Request
  SINGLE_QUOTATION_START: "SINGLE_QUOTATION_START",
  SINGLE_QUOTATION_SUCCESS: "SINGLE_QUOTATION_SUCCESS",
  SINGLE_QUOTATION_ERROR: "SINGLE_QUOTATION_ERROR",
  SINGLE_QUOTATION_RESET: "SINGLE_QUOTATION_RESET",
};

export default types;

